import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import { Request } from "../../models/request/request.model";
import { Response } from "../../models/response/response.model";
import { useCustomNavigation } from "../useCustomNavigation/useCustomNavigation";
import { useLogger } from "../useLogger/useLogger";

export const useApi = () => {
  let { customNavigation } = useCustomNavigation();

  const { log, logError } = useLogger();

  const startAxiosResponseInterceptor = useCallback(() => {
    log("log", "useApi.tsx", "startAxiosResponseInterceptor...");
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        //Http error
        logError("useApi.tsx", "axiosResponseInterceptor", error);
        customNavigation("/GenericError");
      }
    );
  }, [log, logError, customNavigation]);

  const configuration = useCallback(async () => {
    try {
      const response: AxiosResponse<Response> = await axios.get(
        process.env.REACT_APP_API_ENDPOINT +
          "configuration" +
          "?" +
          process.env.REACT_APP_API_BUSINESS_TYPE
      );
      return response;
    } catch (error) {
      logError("useApi.tsx", "configuration resp...", error);
    }
  }, [logError]);

  const startup = useCallback(
    async (body: Request) => {
      try {
        const response: AxiosResponse<Response> = await axios.post(
          process.env.REACT_APP_API_ENDPOINT +
            "startup" +
            "?" +
            process.env.REACT_APP_API_BUSINESS_TYPE,
          body
        );
        return response;
      } catch (error) {
        logError("useApi.tsx", "startup resp...", error);
      }
    },
    [logError]
  );

  const stepLoader = useCallback(
    async (body: Request) => {
      try {
        const response: AxiosResponse<Response> = await axios.post(
          process.env.REACT_APP_API_ENDPOINT +
            "stepLoader" +
            "?" +
            process.env.REACT_APP_API_BUSINESS_TYPE,
          body
        );
        return response;
      } catch (error) {
        logError("useApi.tsx", "stepLoader resp...", error);
      }
    },
    [logError]
  );

  const citiesByZip = useCallback(
    async (zip: string) => {
      try {
        const response: AxiosResponse<string[]> = await axios.get(
          process.env.REACT_APP_API_ENDPOINT + "getCities?zip=" + zip
        );
        return response;
      } catch (error) {
        logError("useApi.tsx", "citiesByZip resp...", error);
      }
    },
    [logError]
  );

  return {
    startAxiosResponseInterceptor,
    configuration,
    startup,
    stepLoader,
    citiesByZip,
  };
};
